<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records interaction-checker">
            <div class="row">
                <div class="col-12 mb-4 Order Confirmed">
                    <div class="bg-white border-radius-5 p-5 Order">
                        <div class="card border-0">
                            <div class="card-body p-0">
                                <div class="row no-gutters justify-content-center">
                                    <div class="col-md-9">
                                        <div class="text-center border-radius-8 p-4 mb-5 interaction">
                                            <h2 class="mb-4">Drug Interaction Checker</h2>
                                            <div class="row justify-content-center">
                                                <div class="col-md-10">
                                                    <div class="input-group mb-5 position-relative">
                                                        <input type="text" name="text" placeholder="Enter a drug, OTC or herbal supplement." />
                                                        <p class="Interaction red">1 Interaction found</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row no-gutters Patient">
                                                <div class="col-md-7 pr-2">
                                                    <div class="d-flex justify-content-between mb-2">
                                                        <h3>Patient Regimen</h3>
                                                        <a href="#">Clear All<i class="icon icon-close"></i></a>
                                                    </div>
                                                    <div class="mb-4 d-flex justify-content-between border-radius-5 bg-white px-3 py-2 align-items-center Regimen">
                                                        <div class="text-left">
                                                            <h4>Terlparatide</h4>
                                                            <p>.parathyroid hormone</p>
                                                        </div>
                                                        <a href="#"><i class="icon icon-close"></i></a>
                                                    </div>
                                                    <div class="mb-4 d-flex justify-content-between border-radius-5 bg-white px-3 py-2 align-items-center Regimen">
                                                        <div class="text-left">
                                                            <h4>Cinnamon</h4>
                                                            <p>.parathyroid hormone</p>
                                                        </div>
                                                        <a href="#"><i class="icon icon-close"></i></a>
                                                    </div>
                                                    <div class="mb-4 d-flex justify-content-between border-radius-5 bg-white px-3 py-2 align-items-center Regimen">
                                                        <div class="text-left">
                                                            <h4>acetarminophen/phenylephrine</h4>
                                                        </div>
                                                        <a href="#"><i class="icon icon-close"></i></a>
                                                    </div>
                                                </div>
                                                <div class="col-md-5 pl-2 mt-4">
                                                    <div class="bg-white border-radius-8 p-3 Monitor-Closely text-left">
                                                        <h4>Monitor Closely</h4>
                                                        <p>Pentazocine + phenylephrine</p>
                                                        <p>Pentazocine increases and phenylephrine decreases sedation. Effect of interation is not clear, use caution. Use Caution/Monitor.</p>
                                                        <a href="#" class="back-to-top">Back to top</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    export default {
        name: "prescription-drug-interaction",
        data() {
            return {};
        },
        created(){
           this.pageName('Drug Interaction Checker')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/prescription/prescription-drug-interaction.vue